import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/38_card_back_museum/38_card_back_museum"
 * Contains 1 texture(s)
 */
export class CardsBacks38CardBackMuseumAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/38_card_back_museum/38_card_back_museum';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '38_museum.png'
    ] as const;
}
